import React, { forwardRef } from 'react';
import { useTextInputAction } from '../TextInputAction';
import Loader from '../../../Button/Loader';
import classNames from 'classnames';

interface IButtonProps extends React.ComponentProps<'button'> {
  dataTestId?: string;
  children: React.ReactNode;
}

export const Button = forwardRef<HTMLButtonElement, IButtonProps>(
  ({ children, dataTestId, ...props }, ref) => {
    const { isLoading } = useTextInputAction();

    return (
      <button
        className="tw-lf-button tw-lf-button-primary tw-lf-button-md tw-relative tw-float-right tw-h-full tw-w-fit tw-rounded-l-none tw-rounded-r-full tw-grid-area-[button] peer-disabled:tw-cursor-not-allowed"
        data-testid={dataTestId}
        {...props}
        ref={ref}
      >
        {isLoading && (
          <span className="tw-absolute tw-right-0 tw-top-0 tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center">
            <Loader />
          </span>
        )}
        <span className={classNames({ 'tw-opacity-0': isLoading })}>
          {children}
        </span>
      </button>
    );
  },
);
